<template>
  <div>
    <el-card
        class="item-card"
        shadow="never"
        style="border-radius: 4px !important; border: 1px solid #dee5ec;"
        body-style="margin: 0px;">
      <el-table
          :data="shippingData"
          :show-header="false"
          class="table-hover"
          row-class-name="table-hover"
          cell-class-name="table-hover"
          :highlight-current-row="false"
          style="width: 100% "
          @expand-change="expandRow">
        <el-table-column
            type="expand">
          <template
              slot-scope="props">
            <div style="margin-left: 60px">
              <div
                  class="flex flex-row"
                  style="margin: 0px 12px 8px 0px">
                <div style="font-weight: 500">
                  Shipped on:
                </div>
                <div style="margin-left: 2px">
                  <time-zone-formatter
                      output-format="MMM DD, YYYY"
                      :current-time="props.row.shipping_date" />
                </div>
              </div>
              <div 
                  class="shipment-current-status-full">
                <strong>Current Status:</strong> {{ props.row.current_status }}
                <small class="shipment-current-status-full-last-update">Last Updated: {{ props.row.current_status_timestamp || 'N/A' }}</small>
              </div>
              <div
                  style="margin: 0px 12px 8px 0px"
                  class="flex flex-row">
                <div style="font-weight: 500">
                  Estimated arrival:
                </div>
                <div style="margin-left: 2px">
                  <time-zone-formatter
                      output-format="MMM DD, YYYY"
                      :current-time="props.row.estimated_arrival_date" />
                </div>
              </div>
              <br>
              <div
                  style="margin: 0px 8px 8px 0px"
                  class="flex flex-row">
                <div>
                  Items Shipped
                </div>
              </div>
              <div
                  id="order-details-item">
                <shipping-details
                    v-for="(item, idx) in props.row.shipment_items"
                    :key="idx"
                    v-bind="item"
                    :shipment-data="props.row.shipment_items[idx]"
                    style="margin-bottom: 8px" />
              </div>
            </div>
          </template>
        </el-table-column>
        <br>
        <el-table-column prop="shipment_provider">
          <template slot-scope="scope">
            <strong>{{ scope.row.shipping_provider }}</strong><br>
            Track ID: <a
                v-if="scope.row.track_id"
                :href="`https://www.swiship.com/track/?id=${scope.row.track_id}`"
                target="_blank">{{ scope.row.track_id }}</a>
            <span v-else>
              No information
            </span>
            <el-tag  
                v-if="scope.row.current_status && !scope.row.expanded"
                type="primary"
                class="shipment-current-status">
              {{ scope.row.current_status }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import numeral from "numeral";
import ShippingDetails from "./ShippingDetails";
import ShipmentDetailsNotAvailable from "./ShipmentDetailsNotAvailable.vue";

export default {
  name: "ShippingDetailsItemView",
  components: {
    ShippingDetails,
    ShipmentDetailsNotAvailable,
  },
  props: {
    shippingData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      expandRow: (row, expandedRows) => {
        console.log(row, expandedRows);
        const expanded = expandedRows.find((r) => r.track_id === row.track_id);
        row.expanded = !!expanded;
      },
    };
  },
  computed: {},
};
</script>

<style>
.el-table.table-hover td {
  border-bottom: 1px solid #ffffff !important;
}
.el-table__expand-icon {
  font-size: 12px !important;
}

.el-table__expand-icon > .el-icon {
  font-size: 16px !important;
  transform: rotate(90deg) !important;
}
.el-table__expand-icon--expanded {
  -webkit-transform: rotate(0deg);
  font-size: 16px !important;
  transform: rotate(180deg) !important;
}

.el-table.table-hover td {
  border-bottom: 1px solid #ffffff !important;
}

.table-hover tbody tr:hover td,
.table-hover tbody tr:hover th {
  background-color: #ffffff !important;
}

.shipment-current-status {
  position: absolute;
  right: 14px;
  top: 14px;
}
.shipment-current-status-full {
  margin-bottom: 10px;
}
.shipment-current-status-full-last-update {
  display: block;
  font-size: 12px;
}
</style>
